<template>
  <div class="info-container mt-3 mb-1">
    <div class="">
      <h2 class="header-info">Tekintse meg kategória-térképünket</h2>
      <p>
        Ha kíváncsi arra, hogy milyen egyéb célokhoz nyújthat megoldási lehetőséget a Forrástérkép, kattintson a lenti
        gombra.
      </p>
    </div>
    <b-button class="button" @click="navigateToCategoryMap">Tovább a kategória-térképre</b-button>
  </div>
</template>

<script>
export default {
  methods: {
    navigateToCategoryMap() {
      this.$router.push('/fund-map/search/category-map')
    }
  }
}
</script>

<style scoped>
.header-info {
  font-weight: 700;
  font-size: 20px;
}

.info-container {
  padding: 24px 16px;
  border-radius: 8px;
  background-color: #ecf0f2;
}
.button {
  background-color: white;
}
</style>
